import { useState, type HTMLProps, type ReactElement } from 'react';

export const Img = ({
  fallback,
  ...props
}: HTMLProps<HTMLImageElement> & {
  fallback: ReactElement;
}) => {
  const [hasError, setHasError] = useState(false);

  if (hasError) {
    return fallback;
  }

  // biome-ignore lint: The linter doesn't understand very well what we're doing here.
  return <img loading="lazy" onError={() => setHasError(true)} {...props} />;
};
